import { Directive, ElementRef, OnInit, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[etsScrollToBottom]'
})
export class ScrollToBottomDirective implements OnInit, AfterViewInit {
  element: ElementRef

  constructor(private el: ElementRef) {
    this.element = el;
  }
  
  ngOnInit() {
    this.scrollToBottom();
  }
   
  ngAfterViewInit() {        
    this.scrollToBottom();        
  } 
  scrollToBottom() {
    try {
      this.element.nativeElement.scrollTop = this.element.nativeElement.scrollHeight;
    } catch (err) { 
      console.log(err); 
    }
  }

}
